import { useMutation } from 'react-query'
import putRegisterService from '../services/putRegisterService'

function usePutRegisterService() {

  return useMutation((value:object)=>putRegisterService(value) );
}

export default usePutRegisterService
